(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-config"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initConfigurableProducts() {

    document.querySelectorAll('variant-radios').forEach(function (variantRadios) {

      if (variantRadios.dataset.configUiReady === 'true') return;

      const configurationInputs = variantRadios.querySelectorAll(
        'input[name="Configuration"]'
      );

      if (!configurationInputs.length) return;

      variantRadios.dataset.configUiReady = 'true';


      // -------------------------
      // Dynamic configuration label
      // -------------------------

      const hasBattery = !!variantRadios.querySelector(
        'input[name="Battery"]'
      );

      const hasCharger = !!variantRadios.querySelector(
        'input[name="Charger"]'
      );

      configurationInputs.forEach(function (input) {

        if (input.value !== 'With Battery + Charger') return;

        const label = variantRadios.querySelector(
          'label[for="' + input.id + '"]'
        );

        if (!label) return;

        let newText = 'With Battery + Charger';

        if (hasBattery && !hasCharger) {
          newText = 'With Battery';
        }

        if (!hasBattery && hasCharger) {
          newText = 'With Charger';
        }

        const hidden = label.querySelector('.visually-hidden');

        Array.from(label.childNodes).forEach(function (node) {
          if (node.nodeType === Node.TEXT_NODE) {
            node.textContent = '';
          }
        });

        label.insertBefore(
          document.createTextNode(newText),
          hidden || null
        );

      });


      // -------------------------
      // Helpers
      // -------------------------

      function getFieldset(name) {

        const input = variantRadios.querySelector(
          'input[name="' + name + '"]'
        );

        return input ? input.closest('fieldset') : null;
      }


      function clickOption(name, value) {

        const input = Array.from(
          variantRadios.querySelectorAll(
            'input[name="' + name + '"]'
          )
        ).find(function (input) {
          return input.value === value;
        });

        if (input && !input.checked) {
          input.click();
        }
      }


      function clickFirstRealOption(name) {

        const current = variantRadios.querySelector(
          'input[name="' + name + '"]:checked'
        );

        if (
          current &&
          current.value !== 'Not required'
        ) {
          return;
        }

        const firstReal = Array.from(
          variantRadios.querySelectorAll(
            'input[name="' + name + '"]'
          )
        ).find(function (input) {
          return input.value !== 'Not required';
        });

        if (firstReal) {
          firstReal.click();
        }
      }


      // -------------------------
      // Main UI logic
      // -------------------------

      function updateUI() {

        const configuration = variantRadios.querySelector(
          'input[name="Configuration"]:checked'
        );

        if (!configuration) return;

        const batteryFieldset = getFieldset('Battery');
        const chargerFieldset = getFieldset('Charger');


        if (configuration.value === 'Body Only') {

          clickOption('Battery', 'Not required');
          clickOption('Charger', 'Not required');

          if (batteryFieldset) {
            batteryFieldset.style.display = 'none';
          }

          if (chargerFieldset) {
            chargerFieldset.style.display = 'none';
          }

        } else {

          if (batteryFieldset) {
            batteryFieldset.style.display = '';
          }

          if (chargerFieldset) {
            chargerFieldset.style.display = '';
          }

          clickFirstRealOption('Battery');
          clickFirstRealOption('Charger');

        }

      }


      configurationInputs.forEach(function (input) {

        input.addEventListener('change', function () {

          setTimeout(updateUI, 20);

        });

      });


      updateUI();

    });

  }


  initConfigurableProducts();


  document.addEventListener(
    'shopify:section:load',
    initConfigurableProducts
  );

})();


  } catch(e) { console.error(e); }
})();
})();
